import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { tokens, sharedStyles } from "../styles";

// Pill-shaped badge with a state-driven palette.
// Mirrors the various small color-coded tags in the prototype:
// "Rescheduled", "New", "Packed", "Unpacked", "Partially Packed", "Misroute",
// connecting-crate ids, preferred-localities, etc.
//
// `state` keys: preferred | new | rescheduled | packed | unpacked | partial | misroute | ofd | neutral
// (anything else falls back to neutral)
// Optional `iconPrefix` — small unicode glyph rendered before the label.

const StatusBadge = ({ label, state = "neutral", iconPrefix }) => {
  const palette = tokens.pill[state] || tokens.pill.neutral;
  return (
    <View
      style={[
        sharedStyles.pillBase,
        styles.compact,
        { backgroundColor: palette.bg, borderColor: palette.border },
      ]}
    >
      <Text
        variant="caption_2"
        style={[sharedStyles.pillText, { color: palette.fg }]}
      >
        {iconPrefix ? `${iconPrefix} ` : ""}
        {label}
      </Text>
    </View>
  );
};

export default StatusBadge;

const styles = StyleSheet.create({
  compact: { paddingVertical: 4 },
});
